export const FETCH_USER_URL = '/users/user';
export const CREATE_USER_URL = '/users/users';
export const UPDATE_USER_URL = '/users/user';
